<template>
    <main-content-wrapper>
        <h1 class="text-uppercase">
            {{ title }}
            <span class="text-lowercase" v-html="text"></span>
        </h1>

        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="email-info">
                <b>Niste prejeli sporočila na vaš elektronski naslov?</b><br />
                Preverite vsiljeno pošto.
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import utils from "../store/utils";


    export default {
        name: "EmailSent",
        components: {MainContentWrapper},
        computed: {
            title: utils.vuexBuildSetGet(this, 'application', 'sent_email.title'),
            text: utils.vuexBuildSetGet(this, 'application', 'sent_email.text')
        }
    }
</script>

<style scoped>
.text {
    text-align: center;
    font-weight: 500;
}

.email-info{
    background-color: #f6f6f6;
    color: black;

}
</style>